import { Info } from "lucide-react";

/**
 * Neutral notice above a resumed DocuSeal embed: the vendor autosaved the
 * signer's previous progress, so the document opens as they left it.
 * Deliberately not the purple AI disclosure — that renders once, on the open
 * that applied the prefill; by closing the form with those values in place
 * and coming back, the signer has accepted them as their own answers. The
 * copy claims only continuity, never authorship of the values: in rare
 * failure windows (a lost response after the vendor write) prefill can land
 * without its disclosure ever having been seen.
 */
export function PdfResumeNotice() {
  return (
    <div
      role="status"
      className="flex items-center gap-1.5 border-b border-gray-100 bg-gray-50 px-4 py-2 text-xs text-gray-600 sm:text-sm"
    >
      <Info size={16} className="shrink-0 text-gray-400" aria-hidden="true" />
      Picking up where you left off — the form is just as you left it.
    </div>
  );
}
